import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { PlusCircle, Building2, DoorOpen } from "lucide-react";
import apiClient from "@/lib/api";
import OwnerLayout from "@/components/owner/OwnerLayout";
import { MetricCard } from "@/components/dashboard/DashboardShell";

const STAT_CARDS = [
  { key: "total", label: "Total Property", hint: "Milik Anda" },
  { key: "draft", label: "Draft", hint: "Belum diajukan" },
  { key: "pending", label: "Menunggu Review", hint: "Sedang ditinjau" },
  { key: "published", label: "Aktif", hint: "Tayang" },
  { key: "rejected", label: "Ditolak", hint: "Perlu diperbaiki" },
  { key: "inactive", label: "Nonaktif", hint: "Disembunyikan" },
];

export default function OwnerDashboard() {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const load = () => {
    setLoading(true);
    setError(false);
    apiClient
      .get("/owner/dashboard/stats")
      .then((r) => setStats(r.data))
      .catch(() => { setStats(null); setError(true); })
      .finally(() => setLoading(false));
  };
  useEffect(load, []);

  const val = (k) => (loading || !stats ? "…" : stats.properties?.[k] ?? 0);

  return (
    <OwnerLayout testid="owner-dashboard">
      <div className="flex items-center justify-between gap-4 flex-wrap">
        <div>
          <h1 className="font-heading text-3xl font-bold tracking-tight">Halo, Pemilik Properti</h1>
          <p className="mt-2 text-sm text-muted-foreground">Kelola property Anda di satu tempat.</p>
        </div>
        <Link to="/owner/properties/new" data-testid="dashboard-add-property"
          className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-accent text-accent-foreground font-semibold hover:scale-105 active:scale-95 transition-transform">
          <PlusCircle size={18} /> Tambah Property
        </Link>
      </div>

      <div className="mt-6 grid grid-cols-2 sm:grid-cols-3 gap-4" data-testid="owner-stats">
        {error && (
          <div className="col-span-full rounded-xl border border-destructive/30 bg-destructive/10 px-4 py-3 text-sm text-destructive flex items-center justify-between gap-3" data-testid="owner-stats-error">
            <span>Gagal memuat statistik.</span>
            <button onClick={load} className="font-semibold underline hover:text-primary" data-testid="owner-stats-retry">Coba lagi</button>
          </div>
        )}
        {STAT_CARDS.map((c, i) => (
          <MetricCard key={c.key} index={i} label={c.label} value={val(c.key)} hint={c.hint} testid={`stat-${c.key}`} />
        ))}
      </div>

      <div className="mt-6 grid sm:grid-cols-2 gap-4">
        <div className="bg-card border border-border rounded-2xl p-6" data-testid="rooms-summary">
          <div className="flex items-center gap-2 mb-2">
            <DoorOpen size={18} className="text-primary" />
            <h3 className="font-heading text-lg font-semibold">Kamar</h3>
          </div>
          <div className="flex gap-8">
            <div>
              <p className="font-heading text-3xl font-bold" data-testid="stat-rooms-total">{loading || !stats ? "…" : stats.rooms?.total ?? 0}</p>
              <p className="text-sm text-muted-foreground">Total kamar</p>
            </div>
            <div>
              <p className="font-heading text-3xl font-bold text-emerald-600" data-testid="stat-rooms-available">{loading || !stats ? "…" : stats.rooms?.available ?? 0}</p>
              <p className="text-sm text-muted-foreground">Tersedia</p>
            </div>
          </div>
        </div>

        <div className="bg-card border border-border rounded-2xl p-6">
          <div className="flex items-center gap-2 mb-2">
            <Building2 size={18} className="text-primary" />
            <h3 className="font-heading text-lg font-semibold">Property Saya</h3>
          </div>
          <p className="text-sm text-muted-foreground">
            Anda memiliki {val("total")} property.{" "}
            <Link to="/owner/properties" className="font-semibold text-primary hover:underline" data-testid="dashboard-view-properties">
              Lihat semua →
            </Link>
          </p>
        </div>
      </div>
    </OwnerLayout>
  );
}
